import TzSelect from './tzselect.vue'
export default TzSelect
